import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Menu, MenuItem } from "@vapor/react-material";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { getOrderDocument } from "../../../../actions/orders";
import {
    hideLockOverlay,
    showLockOverlay,
    showNotificationOverflow,
} from "../../../../actions/ui";
import { OrderInterface } from "../../../../interfaces/orders";
import { ProductInterface } from "../../../../interfaces/products";
import { downloadContent } from "../../../../services/files-operations";
import Tag from "../../../vapor/tag";
import "./style.scss";

declare const window: any;

interface BoughtOrderCardProps {
    order: OrderInterface;
    products: Array<ProductInterface>;
}

const BoughtOrderCard = (props: BoughtOrderCardProps) => {
    const { order, products } = props;
    const productFind = products.find(
        (product: ProductInterface) => product.product === order.product,
    );
    const requestDate = useIntl().formatDate(order.request_date, {
        dateStyle: "long",
    });

    const dispatch: any = useDispatch();

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const downloadDocument = (format?: string) => {
        dispatch(showLockOverlay(true, "Download documento in corso..."));
        dispatch(getOrderDocument(order.order_id, format || "PDF"))
            .then((res: any) => {
                dispatch(hideLockOverlay());
                downloadContent(
                    res,
                    `${order.product}_${order.fiscal_code}.${format || "PDF"}`,
                );
                window?.aptrinsic?.(
                    "track",
                    "business-information:DOWNLOAD-DOCUMENT",
                );
            })
            .catch((err: any) => {
                dispatch(hideLockOverlay());
                dispatch(
                    showNotificationOverflow(
                        "Errore",
                        "Si è verificato un errore durante il download del documento",
                        "error",
                    ),
                );
            });
    };

    return (
        <div className="bis-cards-bought-order-container">
            <div className="bis-cards-bought-order-subtitle">{order.name}</div>
            <div className="bis-cards-bought-order-title">
                {productFind?.name}
            </div>
            <div className="bis-cards-bought-order-footer">
                {order.status === "COMPLETE" && (
                    <>
                        <div className="simple-text">
                            <FormattedMessage id="general.lastBought" />
                            <span>{requestDate}</span>
                        </div>
                        <div className="bis-cards-bought-order-icon">
                            {productFind?.formats.length === 1 && (
                                <div
                                    onClick={() => {
                                        if (order.status === "COMPLETE") {
                                            downloadDocument(
                                                productFind?.formats[0],
                                            );
                                        }
                                    }}
                                >
                                    <FontAwesomeIcon
                                        icon={["far", "download"]}
                                    />
                                </div>
                            )}
                            {productFind?.formats.length !== 1 && (
                                <>
                                    <Menu
                                        id="basic-menu"
                                        anchorEl={anchorEl}
                                        open={open}
                                        onClose={handleClose}
                                        MenuListProps={{
                                            "aria-labelledby": "basic-button",
                                        }}
                                    >
                                        {productFind?.formats.map((it) => {
                                            return (
                                                <MenuItem
                                                    onClick={() => {
                                                        downloadDocument(it);
                                                        handleClose();
                                                    }}
                                                    key={"order-download_" + it}
                                                >
                                                    <FormattedMessage id="actions.download" />
                                                    <span
                                                        style={{
                                                            marginLeft: 4,
                                                        }}
                                                    >
                                                        {it.toLocaleLowerCase()}
                                                    </span>
                                                </MenuItem>
                                            );
                                        })}
                                    </Menu>
                                    <div
                                        onClick={(e) => {
                                            if (order.status === "COMPLETE") {
                                                handleClick(e);
                                            }
                                        }}
                                    >
                                        <FontAwesomeIcon
                                            icon={["far", "download"]}
                                        />
                                    </div>
                                </>
                            )}
                        </div>
                    </>
                )}
                {order.status === "PENDING" && (
                    <>
                        <div>
                            <Tag ghost>
                                <FormattedMessage id="general.pending" />
                            </Tag>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default BoughtOrderCard;
